export default {"src":"/_next/static/media/capy_happy.603c7293.svg","height":225,"width":314};